import client from "../client";

export const milestonesApi = {
    /** Full catalogue merged with the child's saved selections. */
    async list(childId) {
        const { data } = await client.get(`/milestones/${childId}`);
        return data;
    },
    /**
     * Bulk upsert. `entries` is an array of `{ milestoneKey, selection }`.
     * `selection: null` clears a previously-saved row.
     * Returns the merged catalogue after the write.
     */
    async bulkUpsert(childId, entries) {
        const { data } = await client.put(`/milestones/${childId}`, { entries });
        return data;
    },
    /**
     * Reminders → Milestones CDSS feed.
     * Returns `{ items: MissedMilestoneRow[] }` — children whose age has
     * crossed a milestone's band upper bound, with no recorded 'yes'.
     * 'yes' rows are filtered server-side so they never appear here.
     */
    async getWatchlist() {
        const { data } = await client.get(`/milestones/watchlist`);
        return data;
    },
};
